import {FormattedMessage} from "react-intl";
import formatPrice from "@utils/formatPrice";
import "./style.scss";

const DisplayPriceWithLabel = (
    {
        price,
        label,
        isLabelSmall = false,
        isLabelBold = false,
        isPriceBold = false,
        isPriceLarge = false,
        isPriceLarger = false,
        isLineThrough = false,
        isPriceMedium = false,
        altLabel
    }
) => {
    price = parseInt(price);

    if (!price) {
        if (altLabel)
            return <span>{altLabel}</span>
        return;
    }

    return (
        <span className={isLineThrough ? "line-through" : ""}>
            <span
                className={`${isPriceBold && "font-weight-bolder"} ${isPriceLarge && "font-medium-2"} ${isPriceLarger && "font-large-1"} ${isPriceMedium && "font-medium-3"}  font-iran-sans`}>
                {formatPrice(price)}

            </span>
            {" "}

            {label ?
                isLabelSmall ?
                    <small className={isLabelBold ? "font-weight-bolder" : ""}>
                        <FormattedMessage id={label}/>
                    </small>
                    :
                    <span className={isLabelBold ? "font-weight-bolder" : ""}>
                    <FormattedMessage id={label}/>
                 </span>
                : null
            }
        </span>
    );
}

export default DisplayPriceWithLabel;
